import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import BackgroundPicker from 'lib/ui/form/BackgroundPicker'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import Slider from 'lib/ui/Slider'
import Switch from 'lib/ui/form/Switch'
import {onChangeCheckedHandler} from 'lib/dom'
import {CountDownTimerSettings} from 'Event/Dashboard/components/CountDownTimer'

export default function BackgroundSection(props: {
  control: UseFormMethods['control']
  countDownTimer: CountDownTimerSettings
  namePrefix?: string
}) {
  const {control, countDownTimer, namePrefix = ''} = props

  return (
    <CollapsibleSection label="Background">
      <Controller
        name={`${namePrefix}background.color`}
        control={control}
        defaultValue={countDownTimer.background.color}
        render={({value, onChange}) => (
          <BackgroundPicker
            label="Background"
            background={value}
            onChange={onChange}
          />
        )}
      />

      <Controller
        name={`${namePrefix}background.padding`}
        control={control}
        defaultValue={countDownTimer.background.padding}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Padding"
            aria-label="background padding"
          />
        )}
      />

      <Controller
        name={`${namePrefix}background.opacity`}
        control={control}
        defaultValue={countDownTimer.background.opacity || 100}
        render={({value, onChange}) => (
          <Slider
            min={0}
            max={100}
            onChange={onChange}
            valueLabelDisplay="off"
            value={value}
            label="Opacity"
            aria-label="background opacity"
          />
        )}
      />

      <Controller
        name={`${namePrefix}background.fullWidth`}
        control={control}
        defaultValue={countDownTimer.background.fullWidth}
        render={({value, onChange}) => (
          <Switch
            labelPlacement="end"
            label="Full width"
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
            aria-label="full width background"
          />
        )}
      />
    </CollapsibleSection>
  )
}
